module.exports = __webpack_public_path__ + "static/kara-swisher-1c78627037fe576929e0a4116f7944cd.jpg";